import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnAR: CultureInfo = {
  name: 'en-AR',
  displayName: 'English (Argentina)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-AR',
  parent: CultureInfoEn
};
